import React, { useEffect, useState } from "react";
import Table from "../../utilities/Table";
import axios from "axios";
import { bannerColumns } from "../../utilities/utility";
import PromotionCard from "../components/promotions/PromotionCard";

export default function Promos() {
  const [coupons, setCoupon] = useState([]);
  const getcoupons = async () => {
    const response = await axios.get("/api/promo/");
    setCoupon(response.data.data);
  };
  useEffect(() => {
    getcoupons();
  }, []);
  return (
    <div className="wrapper wrapper-content">
      <PromotionCard total={coupons.length} />
      <Table title="Campaigns" data={coupons} columns={bannerColumns} />
    </div>
  );
}
